import { VideoTimeline } from './video_timeline';

Alpine.data('videoTimeline', () => new VideoTimeline());
